/// <reference path="../stores-detail/stores.module.ts" />
import { Component, Inject, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { AlertComponent } from 'ngx-bootstrap/alert/alert.component';
import { Strings } from '../../../common/language/strings';
import { res } from '../../../common/language/text/res';
import { BsModalRef, BsModalService, ModalDirective } from 'ngx-bootstrap/modal';
import { SESSION_STORAGE, WebStorageService } from 'ngx-webstorage-service';
import { HiddenMenuFacade } from '../../../common/facade/HiddenMenuFacade';
import { StoreFacade } from '../../../common/facade/StoreFacade';
import { HiddenMenuDto } from '../../../common/model/dto/HiddenMenuDto';
import { HiddenMenu } from '../../../common/model/HiddenMenu';
import { Organization } from '../../../common/model/Organization';
import { Router } from '@angular/router';

@Component({
  selector: 'app-module-admin',
  templateUrl: './module-admin.component.html',
  styleUrls: ['./module-admin.component.css']
})
export class ModuleAdminComponent implements OnInit {
  // Language
  public isSpanish = true;
  public language = 0;

  // Loading
  public loading = false;
  public messageLoader = '';

  // alert
  public alerts = [];

  // String Resources
  public res = res;

  // DataTable
  public rows: HiddenMenuDto[];
  public rowsAll: HiddenMenuDto[];
  private filteredRows: HiddenMenuDto[];
  public messagesTable: any = {
    emptyMessage: '',
    totalMessage: ''
  };

  // modal
  public modalStore: BsModalRef;
  public config = {
    ignoreBackdropClick: true // si es false se cierra el modal dar clic fuera de el
  };
  public rowsModal: any[] = [];
  private filteredRowsModal: any[] = [];
    private lsStores: any[] = [];
  public check_selectAll = false;
  private selectedMenu = 0;
  public organizationList: Organization[] = [];
  public AvailableOrganizations: Organization[] =[];
  public selectedOrganization: any[];
  public TenantId = 0;
    strOrganizationSelected: string;



  constructor(
    @Inject(SESSION_STORAGE) private _storage: WebStorageService,
    private modalService: BsModalService,
    public strings: Strings,
    private hiddenMenuFacade: HiddenMenuFacade,
    private storeFacade: StoreFacade,
    private _router: Router
    ) {
      this._storage.set('moduleUrl', this._router.url);
   }

  ngOnInit(): void {
    this.isSpanish = this.strings.getLanguageIsSpanish();

    this.messagesTable.emptyMessage = this.strings.GetText(res.ThereIsNoInformation);
    this.messagesTable.totalMessage = 'Total';
    this.TenantId = this.strings.getTenant();
    this.AvailableOrganizations = this.strings.getAvailableOrganizations();
    this.organizationList = this.AvailableOrganizations.filter(Orga => Orga.tenantId == this.TenantId);
    if (!this.isSpanish) {
      this.language = 1;
    }
    this.messageLoader = this.strings.GetText(res.Loading);
    this.getStores();
  }

  // añadir alert
  addAlert(message: String, type: String) {
    this.alerts = [];
    this.alerts.push({
      type: type,
      msg: message
    });
  }

  // cerrar alert
  onClosed(dismissedAlert: AlertComponent) {
    this.alerts = this.alerts.filter(alert => alert !== dismissedAlert);
  }

  calculateStores(row: HiddenMenuDto) {
    return row.hiddenMenus.length + ' ' + this.strings.GetText(res.Stores);
  }

  updateFilter(event) {
    // get the value of the key pressed and make it lowercase
    const val = event.target.value.toLowerCase();
    // get the key names of each column in the dataset
    const keys = Object.keys(this.filteredRows[0]);
    // assign filtered matches to the active datatable
    this.rows = this.filteredRows.filter(function (item) {
        // iterate through each row's column data
        for (let i = 0; i < keys.length; i++) {
            if (item[keys[i]] != null && (item[keys[i]].toString().toLowerCase().indexOf(val) !== -1 || !val)) {
                return true;
            }
        }
    });
  }

  updateFilterModal(event) {
    // get the value of the key pressed and make it lowercase
    const val = event.target.value.toLowerCase();
    // get the key names of each column in the dataset
    const keys = Object.keys(this.filteredRowsModal[0]);
    // assign filtered matches to the active datatable
    this.rowsModal = this.filteredRowsModal.filter(function (item) {
        // iterate through each row's column data
        for (let i = 0; i < keys.length; i++) {
            if (item[keys[i]] != null && (item[keys[i]].toString().toLowerCase().indexOf(val) !== -1 || !val)) {
                return true;
            }
        }
    });
  }


  getHiddenMenus() {
      this.loading = true;
     
    this.hiddenMenuFacade.GetResume().subscribe(result => {
      if (result.completed) {
        this.rowsAll = result.data;
          this.filteredRows = result.data;
          if (this.rowsAll.length > 0) {
              this.rows = this.rowsAll;
              this.rows.forEach(menu => {
                  menu.hiddenMenus = menu.hiddenMenus.filter(x => this.strOrganizationSelected.includes(x.organizationId));
              });
          }
         
      } else {
        this.addAlert('<strong>' + result.message + '</strong>', 'danger');
      }
      this.loading = false;
    }, error => {
      this.addAlert('<strong>' + error + '</strong>', 'danger');
      this.loading = false;
    });
  }

  getStores() {
    this.loading = true;
    this.storeFacade.GetParticipateQuantum().subscribe(result => {
        if (result.completed) {
            this.lsStores = result.data;
            this.loading = false;
      } else {
        this.addAlert('<strong>' + result.message + '</strong>', 'danger');
        this.loading = false;
      }
    }, error => {
      this.addAlert('<strong>' + error + '</strong>', 'danger');
      this.loading = false;
    });
  }

  // Abrir modal de tiendas seleccionadas
  openModal(template: TemplateRef<any>, row: HiddenMenuDto) {
    this.check_selectAll = false;
    this.selectedMenu = row.catDetId;
    this.fillStoresForModal(row);
    this.modalStore = this.modalService.show(
      template,
      Object.assign({}, { class: 'gray modal-xl' }, this.config)
    );
  }

    fillStoresForModal(row: HiddenMenuDto) {
    this.rowsModal = [];
    this.rowsModal = this.lsStores.filter(x => this.strOrganizationSelected.includes(x.organizationId));
    this.rowsModal.forEach(store => { store.selected = false; } );
    this.check_selectAll = (this.rowsModal.length == row.hiddenMenus.length);
    row.hiddenMenus.forEach(menu => {
      this.rowsModal.forEach(store => {
        if (menu.storeId == store.storeId) {
          store.selected = true;
        }
      });
    });
      this.filteredRowsModal = this.rowsModal;
  }

  checkAll() {
    this.check_selectAll = !this.check_selectAll;
    this.rowsModal.forEach(element => {
      element.selected = this.check_selectAll;
    });
  }

  onChangeSelectedStore(row) {
    row.selected = !row.selected;
  }

  saveStores() {
    const request: HiddenMenu[] = [];
    this.rowsModal.forEach(element => {
      const item = new HiddenMenu();
      item.storeId = element.storeId;
      item.catDetHiddenMenuId = this.selectedMenu;
      item.selected = element.selected;
      request.push(item);
    });
    this.modalStore.hide();
    this.loading = true;
    this.hiddenMenuFacade.PostUpdate(request).subscribe(result => {
      this.loading = false;
      if (result.completed) {
        if (result.message.length == 0) {
            result.message = this.strings.GetText(res.ManageModulesSuccessMessage);
          }
        this.addAlert('<strong>' + result.message + '</strong>', 'success');
          this.getHiddenMenus();
          this.loading = false;
      } else {
        this.addAlert('<strong>' + result.message + '</strong>', 'danger');
        this.loading = false;
      }
    }, error => {
      this.addAlert('<strong>' + error + '</strong>', 'danger');
      this.loading = false;
    });
    }
    onChangeOrganization(selectedOrganization: any[]) {
        this.rows = [];
        this.rows = this.rowsAll;
        this.selectedOrganization = selectedOrganization;

        if (selectedOrganization.length < 1) {
            this.rows = [];
        }
        this.strOrganizationSelected = this.selectedOrganization.map(e => e.organizationId).join(',');

        this.getHiddenMenus();
    }

}
